import React, { useState } from 'react'
import { Button, message, Modal, Upload } from 'antd'
import { SendOutlined, SyncOutlined } from '@ant-design/icons'
import { blue } from '../../../color'
import { inject, observer } from 'mobx-react'
import uploadMyFileStore from './uploadMyFileStore'

const UploadMyFileModal = props => {
  const { visible, parentFolderId, onClose, fileStore } = props
  const { isLoading } = uploadMyFileStore
  const [fileList, setFileList] = useState([])

  const handleImportFile = async () => {
    if (fileList.length === 0) {
      return message.warning('Hãy chọn file!')
    }
    try {
      uploadMyFileStore.isLoading = true

      const uploadPromises = fileList.map(async fileItem => {
        const file = fileItem.originFileObj || fileItem
        const formData = new FormData()
        formData.append('file', file)
        const { data } = await fileStore.uploadFile(formData)
        return {
          name: data.file_name || file.name,
          parentId: parentFolderId,
          gridFsFileId: data.file_id,
          size: file.size,
          mimeType: file.type,
        }
      })

      const fileParams = await Promise.all(uploadPromises)
      const payload = fileParams.length === 1 ? fileParams[0] : fileParams
      await uploadMyFileStore.create(payload)

      closeAndResetForm()

      message.success(
        fileParams.length > 1
          ? `Tải lên ${fileParams.length} file thành công`
          : 'Tải file thành công'
      )
    } catch (err) {
      console.log(err)
      if (err && err.errorCode && err.errorCode === 'FILE_NAME_DUPLICATE') {
        message.error('Tên file đã tồn tại')
      } else {
        message.error(err?.vi || 'Đã có lỗi xảy ra!')
      }
    } finally {
      uploadMyFileStore.isLoading = false
    }
  }

  const handleChangeFile = info => {
    const nextList = (info.fileList || []).filter(
      item => item.status !== 'removed'
    )
    setFileList(nextList)
  }

  const handleRemoveFile = file => {
    setFileList(prev => prev.filter(item => item.uid !== file.uid))
    return true
  }

  const closeAndResetForm = () => {
    setFileList([])
    onClose()
  }

  return (
    <Modal
      title="Tải file lên thư mục"
      footer={null}
      closable={!isLoading}
      maskClosable={!isLoading}
      visible={visible}
      onCancel={() => {
        if (!isLoading) {
          closeAndResetForm()
        }
      }}>
      <Upload
        multiple
        fileList={fileList}
        onChange={handleChangeFile}
        onRemove={handleRemoveFile}
        beforeUpload={() => false}
        showUploadList={true}
        disabled={isLoading}>
        <Button
          disabled={isLoading}
          icon={<SyncOutlined />}
          style={{
            color: blue,
            fontWeight: 500,
          }}>
          Chọn file
        </Button>
      </Upload>

      <Button
        style={{ marginTop: 16, width: '100%' }}
        icon={<SendOutlined />}
        loading={isLoading}
        disabled={isLoading || fileList.length === 0}
        onClick={handleImportFile}
        type={'primary'}>
        Tải lên {fileList.length > 0 ? `(${fileList.length})` : ''}
      </Button>
    </Modal>
  )
}

export default inject(
  'fileStore',
  'resourcesStore'
)(observer(UploadMyFileModal))

